export default __webpack_public_path__ + "static/media/cloud.41ac6362.svg";